window.loadEventDatePicker = function ($element) {
    $element.datepicker({
        dateFormat: 'yy/mm/dd',
        monthNames: [ "1月", "2月", "3月", "4月", "5月", "6月",
                    "7月", "8月", "9月", "10月", "11月", "12月" ],
        dayNamesMin: [ "日", "月", "火", "水", "木", "金", "土" ],
        showMonthAfterYear: true,
        yearSuffix: "年",
        showOn: ''
    });
}

window.loadEventSelect2 = function ($element) {
    $element.select2({width: "100%"});
}

window.startLoading = function ($element, $listElement) {
    $listElement.addClass('loading');
    $element.removeClass('d-none');
}

window.endLoading = function ($element, $listElement) {
    $listElement.removeClass('loading');
    $element.addClass('d-none');
}

window.dialogConfirm = function (callback) {
    let params = arguments,
    dialogConfirm = $('#dialog_confirm');
    $('#confirm_message_content').html(params[1]);
    dialogConfirm.modal('show');
    dialogConfirm.find('#button_confirm_yes').off('click').on("click", function (e) {
        dialogConfirm.modal('hide');
        $('#btnUploadId').prop('disabled', true);
        setTimeout(function () {
            callback(params);
        }, 300);
    });
}
window.tableSortInit = function (arrSortColumn, urlParams, addClass = true) {
    let idCurrent = urlParams.sort_column;
    arrSortColumn.forEach((value) => {
        let sortColumnDiv = $('#' + value);
        if (sortColumnDiv.length > 0 && !sortColumnDiv.hasClass('sorter-false')) {
            if (value == idCurrent) {
                if (addClass) {
                    if (urlParams.sort_type == 0) {
                        sortColumnDiv.addClass('chevron-down');
                    } else {
                        sortColumnDiv.addClass('chevron-up');
                    }
                } else {
                    if (urlParams.sort_type == 0) {
                        sortColumnDiv.append('<div class="chevron-down"></div>');
                    } else {
                        sortColumnDiv.append('<div class="chevron-up"></div>');
                    }
                }
            } else {
                if (addClass) {
                    sortColumnDiv.addClass('sort-icon');
                } else {
                    sortColumnDiv.append('<div class="sort-icon"></div>');
                }
            }
        }
    });
}

window.tableSort = function ($element, arrSortColumn, urlParams, urlSearch, addClass = true) {
    if ($element.hasClass('sorter-false')) {
        return;
    }
    let idCurrent = $element.attr('id');
    var isSort = false;
    let sortType = 1;
    arrSortColumn.forEach((value) => {
        let sortColumnDiv = $('#' + value);
        if (sortColumnDiv.length > 0 && !sortColumnDiv.hasClass('sorter-false')) {
            if (value == idCurrent) {
                if ($element.hasClass('chevron-up') || $element.find('.chevron-up').length > 0) {
                    sortType = 0
                }
                isSort = true;
            } else {
                if (addClass) {
                    sortColumnDiv.addClass('sort-icon');
                } else {
                    sortColumnDiv.append('<div class="sort-icon"></div>');
                }
            }
        }
    });
    if (isSort) {
        if (urlParams.sort_column != undefined) {
            urlParams.sort_column = idCurrent;
            urlParams.sort_type = sortType;
            urlSearch += '?' + jQuery.param(urlParams);
        } else {
            urlSearch += '?' + jQuery.param(urlParams) + '&sort_column=' + idCurrent + '&sort_type=' + sortType;
        }
        window.location.href = urlSearch;
    }
}

window.exportCommon = function (params, url, url_download_file, limitModal, downloadModal, btnDownload = null, errorMessage = null) {
    $.ajax({
        url: url,
        method: 'post',
        headers: {'X-CSRF-TOKEN': $('input[name="_token"]').val()},
        async: false,
        dataType: 'json',
        data: params,
        success: function (response) {
            if (response.status == true) {
                downloadModal.modal('hide');
                if (response.isOver) {
                    limitModal.modal('show');
                    return;
                }
                exportFile(url_download_file, btnDownload, params);
            } else {
                if (errorMessage) {
                    errorMessage.removeClass('d-none');
                    errorMessage.html(notDataSearch);
                }
                downloadModal.modal('hide');
            }
        }
    });
}
window.exportFile = function (url_download_file, btnDownload, params = []) {
    const downloadUrl = url_download_file + '?' + jQuery.param(params);
    const openedTab = window.open(downloadUrl, '_blank');
    if (!openedTab) return;
    // Inactive download button
    $('.' + btnDownload).prop('disabled', true);
    // check status of the new tab
    const checkTabClosed = setInterval(() => {
        if (openedTab.closed) {
            clearInterval(checkTabClosed);
            // Re-enable the button when tab is closed
            $('.' + btnDownload).prop('disabled', false);
        }
    }, 2000);
}
window.showFlashMessageWithAjax = function (type, message) {
    window.scrollTo(0, 0);
    if (message === undefined) {
        return;
    }
    var htmlContent = '<p class="alert ' + type + '"><i class="fas fa-exclamation-triangle me-1"></i>' + message + '</p>';
    var flashMessage = $('.flash-message');
    flashMessage.html(htmlContent);
    flashMessage.fadeIn('slow');
}
window.removeMessageModal = function (idModal, idMessage) {
    $('#' + idModal).on('hidden.bs.modal', function (e) {
        $('#' + idMessage).addClass('d-none');
        $('#' + idMessage + ' strong').text('');
    })
}

    $(document).ready(function () {
    //set datetimepicker
    $('.form .datepicker').each(function () {
        loadEventDatePicker($(this));
    });

    $('.form .datepicker2').each(function () {
        loadEventDatePicker($(this).datepicker({dateFormat: 'yy/mm',showOn: ''}));
    });

    $('.calendar-icon').click(function() {
        loadEventDatePicker($(this).datepicker('show'));
    });

    $('select.select2').each(function () {
        loadEventSelect2($(this));
    });

    function isValidDate(date) {
        var bits = date.split('/');
        var d = new Date(bits[0], bits[1] - 1, bits[2]);
        return d && (d.getMonth() + 1) == bits[1];
    }

    $('.form .datepicker').blur('change', function(date){
        var date = $(this).val();
        if (!isValidDate(date)) {
            $(this).val('');
        }
    })

    if ($('div').hasClass('homepage')) {
        $('.menu').hide();
        $('.menu-top').show();
    } else {
        $('.menu-top').hide();
    }

    $('[data-toggle="tooltip"]').tooltip();

    $(".book-registration li").click(function (e) {
        e.preventDefault();
        $(this).addClass('active');
        $(this).siblings().each(function () {
            $(this).removeClass('active');
        });
    });

    $.tablesorter.addWidget({
        id: "numbering",
        format: function(table) {
            $(".tablesorter-hasChildRow:visible", table.tBodies[0]).each(function(i) {
                $(this).find('td').eq(1).text(i + 1);
            });
        }
    });

    $('#table2').tablesorter({
        theme: 'bootstrap',
        widthFixed: true,
        headerTemplate: '{content} {icon}',
        widgets: ["uitheme", "stickyHeaders", "numbering"],
    }).find('colgroup').remove();

    $('.checkActive').click(function () {
        if ($('.checkActive').is(':checked')) {
            $('#btn-delete').removeAttr('disabled');
            $('#btn-confirm').removeAttr('disabled');
        } else {
            $('#btn-delete').attr('disabled', 'disabled');
            $('#btn-confirm').attr('disabled', 'disabled');
        }
    });

    $("#checkAll").click(function () {
        $('.table input:checkbox').not(this).prop('checked', this.checked);
        $('.table input:checkbox').not(this).not('.empty-row .checkActive').prop('checked', this.checked);
        if($(this).is(':checked')) {
            $('#btn-delete').removeAttr('disabled', 'disabled');
            $('#btn-cart').removeAttr('disabled', 'disabled');
        } else {
            $('#btn-delete').attr('disabled', 'disabled');
            $('#btn-cart').attr('disabled', 'disabled');
        }
    });

    $(".registration-status").on('show.bs.modal', function (e) {
        $("#designated_registration").modal("hide");
        $("#designated_registration_02").modal("hide");
        $("#pre-registration-upload").modal("hide");
    });

    $('.show-modal-temporary-code').click(function () {
        let redirectPage = $('#redirect_page').val();
        let entryCode = $(this).data('entry-code');
        let temporaryCode = $(this).data('temporary-code');
        let updatedDate = $(this).data('updated-at');
        let screenId = $('#screen_id').val();
        $('#temporary_code_modal .entry_code').val(entryCode);
        $('#temporary_code_modal .temporary_code').val(temporaryCode);
        $('#temporary_code_modal .redirect_page').val(redirectPage);
        $('#temporary_code_modal .updated_at').val(updatedDate);
        $('#temporary_code_modal .screen_id').val(screenId);
    })

    $(".paging-custom li:not(:first-child):not(:last-child)").click(function () {
        if(!(typeof screenGY0310 !== 'undefined' && screenGY0310 == "GY0310")){
            $(this).addClass('active');
            $(this).siblings().each(function () {
                $(this).removeClass('active');
            });
        }
    });

    $( ".table_sort .tablesorter-header" ).click(function() {
        $('.tablesorter-header').removeClass('active-icon');
        $(this).addClass('active-icon');
    });

    $('.form-control[readonly], .tablesorter-header').each(function() {
        $(this).attr('tabindex', '-1');
    });

    $(".inputWithIcon .datepicker").attr('maxlength','10');
    $(".inputWithIcon .datepicker2").attr('maxlength','7');

    $('.modal').on('shown.bs.modal', function (e) {
        $("<div class='tabindex-md'></div>").insertBefore('.modal').attr("tabindex","0");
        $("<div class='tabindex-md'></div>").insertAfter('.modal').attr("tabindex","0");
    });
    $('.modal').on('hidden.bs.modal', function (e) {
        $("div").remove(".tabindex-md");
    });

    $('a[data-bs-toggle="tab"]').on('shown.bs.tab', function (e) {
        $('html, body').animate({
            scrollTop: $(".nav-tabs").offset().top - 70
        }, 100);
        var target = e.target.attributes.href.value;
        var ctrl = $(target).find('.form-control:not([readonly]):first');
        if(ctrl.is('input')) {
            ctrl.focus();
        } else if(ctrl.is('select')) {
            ctrl.select2('focus');
        }
    });

    $('.select2-selection__arrow').addClass('fas fa-angle-down')
    $(".select2-selection__rendered").click(function () {
        var arrow = $(this).closest('.select2-selection').find('.select2-selection__arrow')
        $(arrow).toggleClass("fa-angle-down fa-angle-up");
    });

    $("<i></i>").insertAfter('.breadcrumb-item').addClass('fas fa-chevron-right')

    let scrollHeight = 0;
    $(".table-scroll tbody .tableCustomSorter-hasChildRow").each(function(index) {
        scrollHeight += $(this).find('td:first-child').outerHeight();
        if(index == 10) {
            $(".table-wrap").addClass("scrolly2");
            $(".scrolly2").css("height", scrollHeight)
        }
    });
});

let fileHtml = '<li class="dz-image-preview"><span data-dz-name class="dz-name"></span><a\n' +
    ' class="btn btn-upload-delete d-none" href="javascript:void(0);"\n' +
    ' data-id=""\n' +
    ' data-dz-remove><i class="fa fa-trash"></i></a><span data-dz-errormessage class="text-danger"></span></li>';

let optionDropzone = function (option) {
    let optionDefault = {
        url: "/file/post",
        autoProcessQueue: false,
        maxFilesize: (option && option.maxFilesize) ? option.maxFilesize : 200,
        uploadMultiple: (option && option.uploadMultiple) ? option.uploadMultiple : false,
        clickable: (option && option.clickable) ? option.maxFilesize : '#dropzone-button',
        acceptedFiles: (option && option.acceptedFiles) ? option.acceptedFiles : ".txt, .jpeg,.jpg,.png,.gif, .xlsx, .xls ,application/pdf",
        previewTemplate: fileHtml,
        previewsContainer: (option && option.previewsContainer) ? option.maxFilesize : "#fileList",
        paramName: "file",
        dictDefaultMessage: 'こちらにファイルをドロップしてアップロードする。',
        dictFallbackMessage: 'あなたのブラウザではドラッグ＆ドロップファイルのアップロードをサポートしていません。',
        dictFallbackText: '前のようにファイルをアップロードするために以下のフォールバックフォームをご使用ください。',
        dictFileTooBig: 'ファイルが大きすぎる({{filesize}}MiB)。最大のファイルサイズ：{{maxFilesize}}MiB。',
        dictInvalidFileType: 'このタイプのファイルをアップロードすることはできません。',
        dictResponseError: 'サーバーは{{statusCode}}コードで応答しました。',
        dictCancelUpload: 'アップロードを取消する。',
        dictCancelUploadConfirmation: 'このアップロードを取り消しますが、よろしいでしょうか？',
        dictRemoveFile: 'ファイルを削除する。',
        dictMaxFilesExceeded: 'これ以上のファイルをアップロードすることはできません。',
        headers: {
            'X-CSRF-Token': $('input[name="_token"]').val()
        },
        init: function () {
            if (option.uploadMultiple === true) {
                $('.btn-clear-file').addClass('d-none');
            }
            this.on('addedfile', function (file) {
                if (option === undefined || option === null || option.uploadMultiple === false) {
                    if (this.files.length > 1) {
                        this.removeFile(this.files[0]);
                    } else if (this.files.length === 1) {
                        const dT = new DataTransfer();
                        this.files.forEach(function (file) {
                            dT.items.add(file);
                            if (option && option.fileNameLengthMax) {
                                let fileName = file.name;
                                if (fileName.length > option.fileNameLengthMax) {
                                    fileName = fileName.substring(0, option.fileNameLengthMax) + '...';
                                }
                                file.previewTemplate.querySelector('.dz-name').innerHTML = fileName;
                            }
                        })
                        if (option !== null && option.fileId) {
                            option.fileId.files = dT.files;
                        } else {
                            dropzoneUploadFile.files = dT.files;
                        }

                        $('.btnDeleteFile').closest('li').remove();
                    }
                    $(this.element.closest('.dropzone-upload')).find('.btn-clear-file').removeClass('d-none');
                }
            })
            this.on('addedfiles', function (files) {
                if (option !== undefined && option !== null && option.uploadMultiple === true) {
                    $('.btn-upload-delete').removeClass('d-none');
                    const dT = new DataTransfer();
                    this.files.forEach(function (file) {
                        dT.items.add(file);
                        if (option && option.fileNameLengthMax) {
                            let fileName = file.name;
                            if (fileName.length > option.fileNameLengthMax) {
                                fileName = fileName.substring(0, option.fileNameLengthMax) + '...';
                            }
                            file.previewTemplate.querySelector('.dz-name').innerHTML = fileName;
                        }
                    })
                    if (option !== null && option.fileId) {
                        option.fileId.files = dT.files;
                    } else {
                        dropzoneUploadFile.files = dT.files;
                    }
                    $('.btnDeleteFile').closest('li').remove();
                }
            });
            this.on('removedfile', function (files) {
                const dT = new DataTransfer();
                this.files.forEach(function (file) {
                    dT.items.add(file);
                    if (option && option.fileNameLengthMax) {
                        let fileName = file.name;
                        if (fileName.length > option.fileNameLengthMax) {
                            fileName = fileName.substring(0, option.fileNameLengthMax) + '...';
                        }
                        file.previewTemplate.querySelector('.dz-name').innerHTML = fileName;
                    }
                })
                if (option !== null && option.fileId) {
                    option.fileId.files = dT.files;
                } else {
                    dropzoneUploadFile.files = dT.files;
                }
                $(this.element.closest('.dropzone-upload')).find('.btn-clear-file').addClass('d-none');
            })
            this.on('error', function (files, response) {
                console.log(response);
            })
            this.on('errormultiple', function (files, response) {
                console.log(response);
            })
        }
    }
    return Object.assign(optionDefault, option);
}
window.optionDropzone = optionDropzone;
$('.btn-clear-file').on('click', function () {
    $('#btnUploadId').prop('disabled', false);
    if ($('.btn-upload-delete').length > 0) {
        $(this).closest('.dropzone-upload').find('.btn-upload-delete')[0].click();
    }
});
$(".toggle-password").click(function () {
    $(this).toggleClass("fa-eye fa-eye-slash");
    var input = $(this).closest('.password').find('.pass_log')
    input.attr('type') === 'password' ? input.attr('type', 'text') : input.attr('type', 'password')
});

// CF0030_条件クリア
$('#btnResetSearch').click(function () {
    var form = $(this).closest('form');
    form.find("input:not(:disabled,[readonly],:hidden), textarea:not(:disabled)").val("");
    form.find("select").val('').trigger('change');
    form.find("input[type='checkbox']").prop("checked", false);
});

String.prototype.toHalfWidth = function() {
    return this.replace(/[Ａ-Ｚａ-ｚ０-９]/g, function(s) {return String.fromCharCode(s.charCodeAt(0) - 0xFEE0)})
        .replace(/[。．]/g, ".")
        .replace(/[、，]/g, ",")
};

$('.halfwidth-code').bind('blur', function(e) {
    var input = $(this).val().toHalfWidth();
    $(this).val(input);
});

$('.datepicker').bind('blur', function(e) {
    var input = $(this).val().toHalfWidth().replace(/\D/g,'').replace(/(\d{4})(\d{2})(\d{2})/g, '$1/$2/$3');
    if (input.length > 10) {
        $(this).val(input.substr(0,10));
    } else {
        $(this).val(input);
    }
});

$('.datepicker2').bind('blur', function(e) {
    var input = $(this).val().toHalfWidth().replace(/\D/g,'').replace(/(\d{4})(\d{2})/g, '$1/$2');
    $(this).val(input);
    if (input.length > 7) {
        $(this).val(input.substr(0,7));
    } else {
        $(this).val(input);
    }
});

$('.modal-dialog').draggable({
    handle: ".modal-header"
});

$.fn.digits = function() {
    return this.each(function(){
        $(this).text( $(this).text().replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1,") );
    })
}

$(".fm-number").digits();

$(".fm-number").bind('blur', function(e) {
    this.value = this.value.replace(/\D/g,'').replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1,");
});

$('.numeric').bind('blur', function(e) {
    this.value = this.value.replace(/\D/g,'');
});
$(".alphanumericOnly").bind('blur', function(e) {
    this.value = this.value.replace(/[^a-zA-Z0-9]/g, '');
});

function toFullWidth(e) {
  e.value = e.value.replace(/[!-~]/g, fullwidthChar => String.fromCharCode(fullwidthChar.charCodeAt(0) + 0xfee0));
}

$(".fullwidth-char").bind('blur', function(e) {
    toFullWidth(this);
});

$('.disabled_img img').bind('contextmenu', function(e) {
    return false;
});

let screenId = $(location).attr('pathname');
$(".navbar-nav li").each(function( index ) {
    let active = $(this).children('a')[0].pathname;
    if(active == screenId) {
        $(this).addClass("active");
        $(this).closest('.dropdown').closest('li').addClass("active");
    }
});

// Handle error response from ajax
handleErrorResponse = function (jqXHR) {
    let isLoginForm = jqXHR.responseText.indexOf('login_form');
    if (jqXHR.status === 401 || isLoginForm > 0) {
        if (typeof callBackUrlTop !== 'undefined') {
            window.location.href = callBackUrlTop; // redirect to page login
        } else {
            console.log('Session timeout not found url login');
        }
    } else if (jqXHR.status === 403) {
        window.location.href = systemErrorUrl; // redirect to page GY9000
    } else {
        // Is customize error
        return true;
    }
}

// Handle error response from ajax
handleSystemErrorResponse = function (jqXHR){
    if (typeof jqXHR.status !== 'undefined') {
        if (typeof systemErrorUrl !== 'undefined') {
            if (jqXHR.status === 403){
                window.location.href = systemErrorUrl; // redirect to page GY9000
            }
        } else {
            console.log('Not found url GY9000');
        }
    }
}

$('.frm-focus-next-elm').on('keypress', 'input',function (e) {
    if (e.which == 13) {
        let input = $('input:enabled:not(:disabled,[readonly],[type=hidden]), select:enabled, button:enabled, textarea');
        let currentIndex = input.index(this);
        input.each(function() {
            let index = input.index(this);
            if (index > currentIndex) {
                input[index].focus();
                return false;
            }
        });
        return false;
    }
});

let isClickPageLink = false;

$('.paging-custom .page-link').on('click', function (e) {
    $('.page-item').addClass('disabled_link');
    //prevent double click
    if (isClickPageLink) {
         e.preventDefault();
         return;
     }  
     isClickPageLink = true;
});